<!-- 经营渠道 -->
<template>
	<div id="app">
		<HNB active="经营渠道"></HNB>
		<div class="topbg" :style="img1">
			<!-- <img style="width: 100%;" :src="img1"> -->
			<!-- style="max-height: 16.5rem; overflow: hidden; display: flex; justify-content: center; align-items: center;" -->
		</div>
		<div id="Official">
			<div class="top">
				<div class="box" v-for="(item,i) in list" :key="i" @click="choose(i)">
					<span :class="{'active':currentindex==i}"><strong>{{item}}</strong></span>
					<div class="line" v-if="i<(list.length-1)">|</div>
				</div>
			</div>
			<div v-show="this.currentindex==0" style="padding-top: 3rem;">
				<div class="center">
					<div class="svg">
						<SvgIcon :svg-name="'pcAndApp'" size="70"></SvgIcon>
					</div>
					<div class="letter" style="cursor: pointer;">
						<div class="span" v-for="(items,i) in letter" :key="i" @click="open(i)"><strong>{{items}}</strong></div>
					</div>
				</div>

				<div class="center">
					<div class="svg">
						<SvgIcon :svg-name="'phone'" size="70"></SvgIcon>
					</div>
					<div class="letter">
						<div class="span" v-for="(item2,i) in write" :key="i"><strong>{{item2}}</strong></div>
					</div>

				</div>
			</div>

			<div class="shell" v-show="this.currentindex==1">
				<div class="totalname">线下授权经销商</div>
				<div class="choose">
					<SvgIcon :svg-name="'placegreen'" size=" 20" class="svg"></SvgIcon>
					<SvgIcon :svg-name="'down'" size=" 25" class="updownsvg"></SvgIcon>
					<select @change="getvalue($event)" v-model="values">

						<option v-for='(item,i) in place' :value="item">{{item}}</option>
					</select>
				</div>


				<div class="shopbox">
					<div class="shopshell" v-for="(item,i) in totalinfo" v-show='values==item.adress'>
						<div class="shop">
							<div class="shop-title">{{item.name}}</div>
							<div class="shop-write">{{item.write}}</div>
							<div style="display: flex;width: 80%; margin: 0 auto;">
								<SvgIcon :svg-name="'placegreen'" size=" 15" class="shopicon"></SvgIcon>
								<div class="shop-adress">{{item.detailadress}}</div>
								<div class="shop-flag">{{item.style}}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="bottomshell">
					<div class="bottomshell-top">招商信息</div>
					<div class="bottomshell-center">
						<div class="bottomshell-center-box" v-for="item in people">
							<div class="bottomshell-center-box-name">{{item.name}}</div>
							<div class="bottomshell-center-box-info">T.<u>{{item.info1}}</u></div>
							<div class="bottomshell-center-box-info">E.<u>{{item.info2}}</u></div>
						</div>
					</div>
				</div>

			</div>



		</div>
		<BS :BsTitle="bsTitle"></BS>
	</div>
</template>

<script>
	// import totalinfo from '../common/shopinfo.js'
	import SvgIcon from '../components/SvgIcon.vue'
	import HNB from '../components/HeaderNavigationBar.vue'
	import BS from '../components/bottomShow.vue'
	export default {
		name: "app",
		components: {
			HNB,
			BS,
			SvgIcon
		},
		mounted() {
			if (this.$route.query.from) {
				this.currentindex = this.$route.query.from == '线下渠道' ? 1 : 0;
			}
		},
		data() {
			return {
				people: [{
						name: '张经理',
						info1: '13779986211',
						info2: 'john.zhang@lfwellness.com'
					},

				],
				values: '北京',
				list: ['官方网店', '线下渠道'],
				letter: ['天猫旗舰店', '京东旗舰店', '小米有品'],
				write: ['小红书', '丁香医生', '屈臣氏'],
				currentindex: 0,
				bsTitle: ['经营渠道', '官方网店'],
				// img1:this.GL	BAL.imgHost + '/images/shop-bg.png',
				img1: 'background-image: url(' + this.GLOBAL.imgHost + '/images/shop-bg.png);',
				place: ['北京', '上海', '河南', '青岛', '安徽', '天津', '新疆', '重庆', '江西', '河北', '辽宁', '云南', '陕西', '浙江', '广东', '湖南', '江苏', '湖北',
					'福建', '海南', '四川', '贵州', '青海'
				],
				totalinfo: [{
						adress: '北京',
						name: 'UP+北京北苑上品店',
						write: '北京市朝阳区北苑路甲13号上品+城市奥莱购物中心一层UP+',
						detailadress: '北京|朝阳区',
						style: '潮品店',

					},
					{
						adress: '北京',
						name: 'UP+北京房山金泰店',
						write: '北京市房山区长政南街跟怡和北路交叉口金泰广场1楼UP+',
						detailadress: '北京|房山区',
						style: '潮品店',
					},
					{
						adress: '北京',
						name: 'UP+北京槐房万达',
						write: '北京市丰台区槐房南路6号院万达广场一层1036号UP+',
						detailadress: '北京|丰台区',
						style: '潮品店',

					},
					{
						adress: '北京',
						name: 'UP+北京西铁营店',
						write: '北京市丰台区西铁营万达广场B1 1029UP+',
						detailadress: '北京|丰台区',
						style: '潮品店',

					},
					{
						adress: '北京',
						name: 'UP+北京天宫院凯德店',
						write: '北京市大兴区华佗路2号天宫院凯德MALL  B1-28  UP+',
						detailadress: '北京|大兴区',
						style: '潮品店',

					},
					{
						adress: '河南',
						name: 'UP+河南鹤壁万达店',
						write: '河南鹤壁市淇滨区闽江路万达广场一楼1029UP+',
						detailadress: '鹤壁市|淇滨区',
						style: '潮品店',

					},
					{
						adress: '河南',
						name: 'UP+河南惠济万达店',
						write: '郑州市惠济区开元路万达广场三楼中庭中国移动UP+',
						detailadress: '郑州市|惠济区',
						style: '潮品店',

					},
					{
						adress: '河南',
						name: 'UP+河南郑州公主茂店',
						write: '河南省郑州市中原区迎春街与雪松路交汇处西北角公园茂1楼UP+',
						detailadress: '郑州市|中原区',
						style: '潮品店',

					},
					{
						adress: '河南',
						name: 'UP+河南郑州正弘城店',
						write: '河南省郑州市金水区花园路东风路交叉口西南角正弘城6楼625UP+',
						detailadress: '郑州市|金水区',
						style: '潮品店',

					},
					{
						adress: '青岛',
						name: 'UP+山东青岛家乐福名达店',
						write: ' 山东省青岛市市南区香港中路家乐福三楼UP+',
						detailadress: '青岛|南区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'UP+上海奉贤宝龙店',
						write: ' 上海市奉贤区南桥镇航南公路5639号奉贤宝龙广场2号楼053UP+',
						detailadress: '上海|奉贤区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'UP+上海红星国际店',
						write: ' 上海市闵行区虹井路上海之眼风情街1层（新华红星国际广场）UP+',
						detailadress: '上海|闵行区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'UP+上海黄浦新邻店',
						write: '黄浦区陆家浜路1100号新邻生活站B1F-02CUP+',
						detailadress: '上海|黄浦区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'UP+上海嘉定万达店',
						write: '上海市嘉定区胜辛路447号万达广场1068.1069AUP+',
						detailadress: '上海|嘉定区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'UP+上海世博渊店',
						write: '上海市浦东新区世博大道1368号世博源4区B层4B03UP+',
						detailadress: '上海|浦东新区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'UP+上海徐家汇美罗店',
						write: '上海市徐汇区肇嘉浜路1111号美罗城三楼UP+',
						detailadress: '上海|徐汇区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'UP+上海颛桥万达店',
						write: '上海市闵行区都市路2700号万达广场1F 1030-1031UP+',
						detailadress: '上海|闵行区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'UP+上海宝山万达店',
						write: '上海市宝山区一二八纪念路968号宝山万达广场B1层UP+',
						detailadress: '上海|宝山区',
						style: '潮品店',

					},
					{
						adress: '安徽',
						name: 'UP+安徽阜阳万达店',
						write: '安徽省阜阳市颍泉区万达广场up+',
						detailadress: '阜阳市|颍泉区',
						style: '潮品店',

					},
					{
						adress: '天津',
						name: 'UP+天津河西国贸店',
						write: '天津市河西区南京路39号凯德国贸一层F112 ',
						detailadress: '天津|河西区',
						style: '潮品店',

					},
					{
						adress: '新疆',
						name: 'UP+新疆乌鲁木齐昊元店',
						write: '新疆乌鲁木齐市新市区西环北路昊元上品友好时尚购物城一楼UP+',
						detailadress: '乌鲁木齐市|新市区',
						style: '潮品店',

					},
					{
						adress: '新疆',
						name: 'UP+新疆乌鲁木齐黄河路店',
						write: '新疆乌鲁木齐市沙依巴克区黄河路168号联通营业厅',
						detailadress: '乌鲁木齐市|沙依巴克区',
						style: '潮品店',

					},
					{
						adress: '重庆',
						name: 'UP+重庆龙湖天街店',
						write: '重庆石油路街道龙湖时代天街A管UG层A007UP+',
						detailadress: '重庆|渝中区',
						style: '潮品店',

					},
					{
						adress: '重庆',
						name: 'UP+重庆南坪百联上海城',
						write: '重庆市南岸区南坪西路上海城购物中心UP+',
						detailadress: '重庆|南岸区',
						style: '潮品店',

					},
					{
						adress: '江西',
						name: 'UP+江西南昌西湖万达店',
						write: '江西省南昌市西湖区云锦路368号西湖万达2楼UP+',
						detailadress: '南昌市|西湖区',
						style: '潮品店',

					},
					{
						adress: '江西',
						name: 'UP+江西南昌青湖万达店',
						write: '江西省南昌市青山湖区青山湖万达一楼1030UP+ ',
						detailadress: '南昌市|青山湖区',
						style: '潮品店',

					},
					{
						adress: '辽宁',
						name: 'UP+辽宁辽阳新运万达店',
						write: '辽宁省辽阳市文圣区新运大街333号辽阳万达二楼中国移动UP+',
						detailadress: '辽阳市|文圣区',
						style: '潮品店',

					},
					{
						adress: '河北',
						name: 'UP+河北石家庄万象城店',
						write: '河北省石家庄桥西区华润万象城L611室UP+',
						detailadress: '石家庄市|桥西区',
						style: '潮品店',

					},
					{
						adress: '河北',
						name: 'UP+河北石家庄建华城市广场店',
						write: '河北省石家庄市长安区中山路与建华大街交汇处东北角，建华城市广场B1北国超市入口处UP+',
						detailadress: '石家庄市|长安区',
						style: '潮品店',

					},
					{
						adress: '云南',
						name: 'UP+河北石家庄建华城市广场店',
						write: '云南省昆明市环城南路昆明大悦城购物中心   2栋5层2-5-22',
						detailadress: '昆明市|盘龙区',
						style: '潮品店',

					},
					{
						adress: '陕西',
						name: 'UP+西安钟楼未来城店',
						write: '西安市莲湖区北大街22号中国电信UP+未来体验店  ',
						detailadress: '西安市|莲湖区',
						style: '潮品店',

					},
					{
						adress: '浙江',
						name: '武林银泰',
						write: '杭州市下城区武林银泰C馆1楼奇客巴士',
						detailadress: '杭州市|下城区',
						style: '潮品店',

					},
					{
						adress: '浙江',
						name: '嘉兴万达广场',
						write: '浙江省嘉兴市南湖区龙凤路经开万达广场1060奇客巴士（南广场3号门旁）',
						detailadress: '嘉兴市|南湖区',
						style: '潮品店',

					},
					{
						adress: '浙江',
						name: '杭州银泰',
						write: '浙江省杭州市拱墅区莫干山路1418-5号3012室',
						detailadress: '杭州市|拱墅区',
						style: '潮品店',

					},
					{
						adress: '浙江',
						name: '临平银泰',
						write: '浙江省杭州市余杭区南苑街道余杭区世纪大道西1号临平银泰城一层101号商铺 奇客巴士',
						detailadress: '杭州市|余杭区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '上海世茂广场',
						write: '上海市黄浦区南京东路819号世茂广场L3奇客巴士',
						detailadress: '上海|黄浦区',
						style: '潮品店',

					},
					{
						adress: '浙江',
						name: '城西银泰城',
						write: '浙江省杭州市拱墅区萍水街丰潭路380号城西银泰城1F065',
						detailadress: '杭州市|拱墅区',
						style: '潮品店',

					},
					{
						adress: '浙江',
						name: '西湖区银泰',
						write: '浙江省杭州市西湖区双龙街588号 1F022奇客巴士',
						detailadress: '杭州市|西湖区',
						style: '潮品店',

					},
					{
						adress: '广东',
						name: 'SOLOPICK店铺（大白）',
						write: '广州市荔湾区岭南街道西堤二马路37号 广州文化公园一层',
						detailadress: '广州市|荔湾区',
						style: '潮品店',

					},
					{
						adress: '湖南',
						name: '微滨IFS国金中心店',
						write: '湖南省长沙市芙蓉区中山路三角花园星城1708',
						detailadress: '长沙市|芙蓉区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps浦东嘉里城店',
						write: '上海市浦东新区+G38:G96+G38:G98花木路1378号浦东嘉里城商场二层L220号单元',
						detailadress: '上海市|浦东新区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps长宁尚嘉店',
						write: '上海市长宁区仙霞路99号尚嘉中心地下二层久光超市 B-001B',
						detailadress: '上海市|长宁区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps上海来福士店',
						write: '上海市黄浦区西藏中路268号来福士广场B1-10B室',
						detailadress: '上海市|黄浦区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps百联世纪店',
						write: '上海市浦东新区世纪大道1217号百联世纪大都会B1层024室',
						detailadress: '上海市|浦东新区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps环贸店',
						write: '上海市徐汇区淮海中路999号环贸广场3楼328室',
						detailadress: '上海市|徐汇区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps环球港店',
						write: '上海市普陀区中山北路3300号上海环球港1楼L1019室',
						detailadress: '上海市|普陀区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps兴业太古汇店',
						write: '静安区石门一路288号兴业太古汇商场3楼L376铺位',
						detailadress: '上海市|静安区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps世博源店',
						write: '上海市浦东新区世博大道1368号世博源商场3区B层3B43室',
						detailadress: '上海市|东新区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: 'chonps无锡恒隆店',
						write: '江苏省无锡市梁溪区人民中路139号无锡恒隆广场商场地下一层119号',
						detailadress: '上海市|梁溪区',
						style: '潮品店',

					},
					{
						adress: '浙江',
						name: 'chonps宁波来福士店',
						write: '宁波市江北区大庆南路99号来福士广场B1层04&05室',
						detailadress: '宁波市|江北区',
						style: '潮品店',

					},
					{
						adress: '浙江',
						name: 'chonps杭州万象城店',
						write: '浙江省杭州市江干区富春路701号万象B1-S79铺位',
						detailadress: '宁波市|江北区',
						style: '潮品店',

					},
					{
						adress: '浙江',
						name: 'chonps杭州万象汇店',
						write: '杭州市萧山区金城路927号（市心路口）万象汇商场B1层B183室  ',
						detailadress: '杭州市|萧山区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: 'chonps武汉汉街店',
						write: '湖北省武汉市武昌区中北路汉街第一街区0010号',
						detailadress: '武汉市|武昌区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps静安嘉里中心店',
						write: '上海市静安区延安中路1218号静安嘉里中心商场SB1-24号',
						detailadress: '上海|静安区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: 'chonps上海港汇恒隆店',
						write: '上海市徐汇区虹桥路1号3楼362室',
						detailadress: '上海|徐汇区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '宝山万达数码馆',
						write: '上海市宝山区一二八纪念路988弄万达广场3022铺 美承',
						detailadress: '上海|宝山区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '嘉定数码馆',
						write: '上海市嘉定区城中路138号罗宾森广场1楼 美承',
						detailadress: '上海|嘉定区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '江桥万达数码馆',
						write: '上海市嘉定区金沙江西路1051号万达广场1号门2楼2094铺 美承',
						detailadress: '上海|嘉定区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '南汇万达数码馆(DWS)',
						write: '上海市南汇区沪南公路3449弄周浦万达广场218铺 美承',
						detailadress: '上海|南汇区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '青浦吾悦数码馆',
						write: '上海市青浦区漕盈路淀山湖大道交汇处青浦吾悦广场1F035铺 美承',
						detailadress: '上海|青浦区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '金桥易初莲花数码馆',
						write: '上海市浦东新区金高路1256号卜蜂莲花超市1F-20 美承',
						detailadress: '上海|浦东新区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '上海乐虹坊数码馆',
						write: '上海市闵行区虹井路288号乐虹坊1层102室 美承',
						detailadress: '上海|闵行区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '上海宝乐汇数码馆',
						write: '上海市上海市宝山区牡丹江路1569号B1层B115号 美承',
						detailadress: '上海|宝山区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '上海万象城数码馆',
						write: '上海市上海市闵行区吴中路1559号上海万象城L513B商铺 美承',
						detailadress: '上海|闵行区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '莘庄凯德数码馆',
						write: '上海市闵行区沪闵路6088号凯德龙之梦01F48号 美承',
						detailadress: '上海|闵行区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '颛桥万达数码馆',
						write: '上海市闵行区颛桥镇都市路2700号万达广场1楼1076室 美承',
						detailadress: '上海|闵行区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '太仓万达数码馆',
						write: '江苏省苏州市太仓市上海东路188号 万达广场1038BA 美承',
						detailadress: '江苏|太仓市',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '淮安万达数码馆',
						write: '江苏省淮安市清河区翔宇中路169号万达广场1层1-03号商铺 美承',
						detailadress: '淮安市|清河区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '常州丰臣数码馆',
						write: '江苏省常州市新北区通江中路常州丰臣国际广场1-ZX001（时尚城一楼） 美承',
						detailadress: '常州市|新北区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '无锡惠山万达数码馆',
						write: '江苏省无锡市惠山区吴韵路321号万达广场2005-2006A铺 美承',
						detailadress: '无锡市|惠山区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '无锡滨湖万达数码馆',
						write: '江苏省无锡市梁溪路35号万达广场1-67铺 美承',
						detailadress: '无锡市|滨湖区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '苏州金鹰数码馆',
						write: '江苏省苏州市高新区狮山路298号金鹰购物广场1层A-019',
						detailadress: '苏州市|高新区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '江苏常州环球港数码馆',
						write: '常州市新北区通江中路598号环球港L1107-1108',
						detailadress: '常州市|新北区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '江苏苏州中心东方之门数码馆',
						write: '苏州工业园区苏州中心广场5幢B1层（A）B1-21/22',
						detailadress: '苏州市|工业园区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '江苏苏州悠方数码馆',
						write: '江苏省苏州市吴中区木渎镇竹园路与金枫路交汇处金枫路264号1F115号铺',
						detailadress: '苏州市|吴中区',
						style: '潮品店',

					},
					{
						adress: '江苏',
						name: '江苏常州龙湖数码馆',
						write: '常州钟楼区勤业路295号龙湖天街01-1F-12',
						detailadress: '常州市|钟楼区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '汉街旗舰店',
						write: '湖北省武汉市中央文化区商业步行街汉街J2-2-8号商铺2F',
						detailadress: '武汉市|中央文化区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '经开万达店',
						write: '湖北省武汉市经济技术开发区东风大道111号经开万达广场室内步行街2-63，2-65号铺',
						detailadress: '武汉市|经济技术开发区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '菱角湖万达店',
						write: '湖北省武汉市江汉区菱角湖万达广场室内步行街2-37-38-39号铺',
						detailadress: '武汉市|江汉区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '襄阳万达店',
						write: '湖北省襄阳市高新区长虹北路襄阳万达广场室内步行街135号商铺',
						detailadress: '襄阳市|高新区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '宜昌万达店',
						write: '湖北省宜昌市伍家岗区伍家岗万达广场内购物中心室内步行街1层103-1103-2号商铺',
						detailadress: '宜昌市|伍家岗区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '湖北宜昌国贸数码馆',
						write: '湖北省宜昌市西陵区东山大道106号宜昌国贸商场北一美承',
						detailadress: '宜昌市|西陵区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '武汉光谷数码馆',
						write: '湖北省武汉市东湖开发区东湖高新技术开发区珞喻路766号光谷世界城广场1层132、135号商铺',
						detailadress: '武汉市|东湖开发区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '武汉国际广场数码馆',
						write: '湖北省武汉市江汉区解放大道690号武汉国际广场C座5层C5-10-4号商铺',
						detailadress: '武汉市|江汉区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '武汉泛海数码馆',
						write: '湖北省武汉市江汉区武汉CBD泛海城市广场购物中心1-16号商铺',
						detailadress: '武汉市|江汉区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '黄石万达数码馆',
						write: '湖北省黄石市黄石港区万达广场1楼1017号',
						detailadress: '黄石市|黄石港区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '荆门万达数码馆',
						write: '湖北省荆门市漳河新区万达广场室内步行街1层1003号商铺',
						detailadress: '荆门市|漳河新区',
						style: '潮品店',

					},
					{
						adress: '湖北',
						name: '湖北武汉金桥永旺数码馆',
						write: '湖北省武汉市江岸区金桥大道15号永旺梦乐城138a',
						detailadress: '武汉市|江岸区',
						style: '潮品店',

					},
					{
						adress: '福建',
						name: '晋江万达数码馆',
						write: '福建省泉州市晋江市世纪大道888号万达广场室内步行街2层266B、267A号铺',
						detailadress: '晋江市|东石大房工业区',
						style: '潮品店',

					},
					{
						adress: '福建',
						name: '厦门万达数码馆',
						write: '福建省厦门市湖里区仙岳路4666号厦门湖里万达广场二楼232号铺',
						detailadress: '厦门市|湖里区',
						style: '潮品店',

					},
					{
						adress: '福建',
						name: '厦门国贸数码馆',
						write: '福建省厦门市集美区同集南路68号美岁天地一楼L125号',
						detailadress: '厦门市|集美区',
						style: '潮品店',

					},
					{
						adress: '福建',
						name: '福建厦门湾悦城数码馆',
						write: '福建省厦门市湖里区日圆二里路 1 号湾悦城项目二楼0036号商铺',
						detailadress: '厦门市|集美区',
						style: '潮品店',

					},
					{
						adress: '安徽',
						name: '合肥天鹅湖万达数码馆',
						write: '安徽省合肥市蜀山区南二环路3818号天鹅湖万达广场2-38铺 美承',
						detailadress: '合肥市|蜀山区',
						style: '潮品店',

					},
					{
						adress: '安徽',
						name: '合肥包河万达数码馆',
						write: '安徽省合肥市包河区芜湖路包河万达广场室内步行街2楼2-69铺 美承',
						detailadress: '合肥市|包河区',
						style: '潮品店',

					},
					{
						adress: '安徽',
						name: '合肥万象城数码馆',
						write: '安徽省合肥市蜀山区习友路与潜山路交口华润万象城5楼505铺',
						detailadress: '合肥市|蜀山区',
						style: '潮品店',

					},
					{
						adress: '安徽',
						name: '合肥悦方数码馆',
						write: '安徽省合肥市滨湖新区庐州大道2868号悦方ID mall购物中心广场L1层 L146－1号',
						detailadress: '合肥市|滨湖新区',
						style: '潮品店',

					},
					{
						adress: '安徽',
						name: '安徽合肥滨湖银泰数码馆',
						write: '合肥市包河区云谷路1718号滨湖银泰城B1056号铺',
						detailadress: '合肥市|包河区',
						style: '潮品店',

					},
					{
						adress: '安徽',
						name: '安徽合肥万科数码馆',
						write: '安徽省合肥市庐阳区四里河路与固镇路口合肥万科广场1层1024号铺',
						detailadress: '合肥市|庐阳区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '上海青浦万达茂数码馆',
						write: '上海市青浦区青浦万达茂室内步行街1F层B区1001号商铺',
						detailadress: '上海市|青浦区',
						style: '潮品店',

					},
					{
						adress: '上海',
						name: '虹桥高铁Z1店',
						write: '上海市闵行区申兰路1666号虹桥高铁站 2F-2',
						detailadress: '上海市|闵行区',
						style: '机场店',

					},
					{
						adress: '浙江',
						name: '宁波机场Z1店',
						write: '宁波市鄞州区栎社航空路宁波栎社国际机场国内候机楼 D-R-6a 铺',
						detailadress: '宁波市|鄞州区',
						style: '机场店',

					},
					{
						adress: '海南',
						name: '三亚海棠湾Z1店',
						write: '海南省三亚市海棠区海棠湾镇海棠北路118号三亚国际免税城B区二楼',
						detailadress: '三亚市|海棠区',
						style: '机场店',

					},
					{
						adress: '重庆',
						name: '重庆机场Z2店',
						write: '重庆市渝北区两路街道重庆江北国际机场T3A航站楼三层中心商业区 L3E18',
						detailadress: '重庆市|渝北区',
						style: '机场店',

					},
					{
						adress: '重庆',
						name: '重庆机场Z3店',
						write: '重庆市渝北区两路街道重庆江北国际机场T3A航站楼三层F指廊L3C18',
						detailadress: '重庆市|渝北区',
						style: '机场店',

					},
					{
						adress: '重庆',
						name: '重庆机场Z4店',
						write: '重庆市渝北区两路街道重庆江北国际机场航站楼3楼 T2A A 连廊',
						detailadress: '重庆市|渝北区',
						style: '机场店',

					},
					{
						adress: '四川',
						name: '成都机场Z1店',
						write: '成都市迎宾大道成都双流机场T2航站楼EF-R-3',
						detailadress: '成都市',
						style: '机场店',

					},
					{
						adress: '四川',
						name: '成都机场Z2店',
						write: '成都市迎宾大道成都双流机场T2航站楼E-R-13',
						detailadress: '成都市',
						style: '机场店',

					},
					{
						adress: '广东',
						name: '深圳机场Z1店',
						write: '深圳市宝安国际机场T3航站楼出发大厅4L-01-01和4L-01-02',
						detailadress: '深圳市|宝安区',
						style: '机场店',

					},
					{
						adress: '广东',
						name: '深圳机场Z2店',
						write: '深圳市宝安国际机场T3航站楼安检内3C-05-05',
						detailadress: '深圳市|宝安区',
						style: '机场店',

					},
					{
						adress: '广东',
						name: '深圳机场Z3店',
						write: '深圳市宝安国际机场T3航站楼安检内3E-04-05',
						detailadress: '深圳市|宝安区',
						style: '机场店',

					},
					{
						adress: '广东',
						name: '深圳机场Z4店',
						write: '深圳市宝安国际机场T3航站楼到达大厅2H-06-01',
						detailadress: '深圳市|宝安区',
						style: '机场店',

					},
					{
						adress: '广东',
						name: '深圳北站Z1店',
						write: '深圳市龙华新区民治街道广深港高铁深圳北站零售店1F28',
						detailadress: '深圳市|龙华新区',
						style: '机场店',

					},
					{
						adress: '浙江',
						name: '杭州机场Z1店',
						write: '杭州市萧山区萧山国际机场T3航站楼3F-19',
						detailadress: '杭州市|萧山区',
						style: '机场店',

					},
					{
						adress: '浙江',
						name: '杭州机场Z2店',
						write: '杭州市萧山区萧山国际机场T3航站楼3F-06',
						detailadress: '杭州市|萧山区',
						style: '机场店',

					},
					{
						adress: '湖北',
						name: '武汉机场Z1店',
						write: '武汉市黄陂区天河机场T3航站楼4楼出发大厅4D2-35',
						detailadress: '武汉市|黄陂区',
						style: '机场店',

					},
					{
						adress: '贵州',
						name: '贵阳机场Z1店',
						write: '贵阳龙洞堡国际机场T2航站楼出发层8号门安检内2走廊cf-42',
						detailadress: '贵阳市|南明区',
						style: '机场店',

					},
					{
						adress: '青海',
						name: '西宁机场Z1店',
						write: '西宁曹家堡机场T2航站楼C-R-8',
						detailadress: '西宁市',
						style: '机场店',

					},
					{
						adress: '四川',
						name: '成都机场Z3店',
						write: '成都市迎宾大道成都双流机场T2航站楼出发厅D-R-16',
						detailadress: '成都市',
						style: '机场店',

					},
					{
						adress: '四川',
						name: '成都机场Z4店',
						write: '成都市迎宾大道成都双流机场T2航站楼出发厅DEP-R-19',
						detailadress: '成都市',
						style: '机场店',

					},
					{
						adress: '四川',
						name: '成都机场Z5店',
						write: '成都市迎宾大道成都双流机场T2航站楼出发厅G-R-4',
						detailadress: '成都市',
						style: '机场店',

					},
					{
						adress: '四川',
						name: '成都机场Z6店',
						write: '成都市迎宾大道成都双流机场T2航站楼出发厅F-R-4',
						detailadress: '成都市',
						style: '机场店',

					},
					{
						adress: '上海',
						name: '天山店',
						write: '长宁区天山支路201号一层南区1005室',
						detailadress: '上海市|长宁区',
						style: '连锁店',

					},
					{
						adress: '上海',
						name: '新昌店',
						write: '新昌路488号3楼',
						detailadress: '上海市|黄浦区',
						style: '连锁店',

					},
					{
						adress: '上海',
						name: '幸福店',
						write: '虹口区四平路311号317铺恒城花苑底商',
						detailadress: '上海市|虹口区',
						style: '连锁店',

					},
					{
						adress: '上海',
						name: '财富店',
						write: '源深路1088号平安财富大厦1楼东侧101室',
						detailadress: '上海市|浦东新区',
						style: '连锁店',

					},
					{
						adress: '上海',
						name: '长寿店',
						write: '澳门路770号1楼',
						detailadress: '上海市|普陀区',
						style: '连锁店',

					},
					{
						adress: '上海',
						name: '健康店',
						write: '灵石路697号健康智谷7号楼106室',
						detailadress: '上海市|闸北区',
						style: '连锁店',

					},
					{
						adress: '陕西',
						name: '西安省代理',
						write: '西安市碑林区雁塔中路68号百脑汇8楼8A17室',
						detailadress: '西安市|碑林区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '雁塔路赛格小米店',
						write: '雁塔路中段8号赛格电脑城1楼小米授权店',
						detailadress: '西安市|碑林区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '咸阳王刚',
						write: '咸阳玉泉路潮流港一楼',
						detailadress: '咸阳市',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '汉唐书城',
						write: '长安中路91号嘉汇大厦',
						detailadress: '西安市|雁塔区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '立丰国际',
						write: '金花南路6号',
						detailadress: '西安市|碑林区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: 'momopake',
						write: '小寨西路232号',
						detailadress: '西安市|雁塔区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '兰岛广场',
						write: '科技六路与白沙路十字',
						detailadress: '西安市|雁塔区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '华清广场',
						write: '李家村十字华清广场',
						detailadress: '西安市|碑林区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '渭南云米',
						write: '渭南万达广场 吃货街',
						detailadress: '渭南市|临渭区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '小寨银泰',
						write: '小寨银泰城',
						detailadress: '西安市|雁塔区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '铜川小米',
						write: '铜川新区荣盛广场一楼',
						detailadress: '铜川市|铜川新区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '合阳小米',
						write: '渭南市合阳县世丰商业街',
						detailadress: '渭南市|合阳县',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '大融城',
						write: '凤城八路大融城',
						detailadress: '西安市|未央区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '大明宫万达',
						write: '凤城一路',
						detailadress: '西安市|未央区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '老城根',
						write: '星火路22号老城根',
						detailadress: '西安市|莲湖区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '汉中金邦',
						write: '汉中市金台区电信大楼',
						detailadress: '汉中市|汉台区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '隆德县小米',
						write: '宁夏固原市隆德县中央名都',
						detailadress: '宁夏市|回族自治区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '安康陈文权',
						write: '陕西省安康市',
						detailadress: '安康市',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '蓝海风',
						write: '凤城二路蓝海风中心',
						detailadress: '西安市|未央区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '勉县纪超',
						write: '陕西省汉中市勉县二中路小米店',
						detailadress: '汉中市|勉县',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '万和城',
						write: '西安市新城区胡家庙万和城一楼小米',
						detailadress: '西安市|新城区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '李家村万达',
						write: '西安市碑林区雁塔路李家村万达广场',
						detailadress: '西安市|碑林区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '南稍门扣钉潮品',
						write: '西安市碑林区南稍门中贸广场',
						detailadress: '西安市|碑林区',
						style: '区域代理商',

					},
					{
						adress: '陕西',
						name: '汉神广场潮品',
						write: '西安市未央区凤城八路汉神广场',
						detailadress: '西安市|未央区',
						style: '区域代理商',

					},
					{
						adress: '湖北',
						name: '光谷马德里店',
						write: '',
						detailadress: '武汉市|洪山区',
						style: '区域代理商',

					},
					{
						adress: '湖北',
						name: '绿地店',
						write: '',
						detailadress: '武汉市|武昌区',
						style: '区域代理商',

					},
					{
						adress: '湖北',
						name: '汉街店',
						write: '',
						detailadress: '武汉市|武昌区',
						style: '区域代理商',

					},
					{
						adress: '湖北',
						name: '江汉路店',
						write: '',
						detailadress: '武汉市|江汉区',
						style: '区域代理商',

					},
					{
						adress: '湖北',
						name: '南湖店',
						write: '',
						detailadress: '武汉市|洪山区',
						style: '区域代理商',

					},
					{
						adress: '湖北',
						name: '光谷K11店',
						write: '',
						detailadress: '武汉市|洪山区',
						style: '区域代理商',

					},
					{
						adress: '湖北',
						name: '真爱店',
						write: '',
						detailadress: '武汉市|洪山区',
						style: '区域代理商',

					},
					{
						adress: '广州',
						name: '天河海航旗舰店',
						write: '',
						detailadress: '广州市|天河区',
						style: '区域代理商',

					},
					{
						adress: '广州',
						name: '市桥店',
						write: '',
						detailadress: '广州市|番禺区',
						style: '区域代理商',

					},
					{
						adress: '广州',
						name: '萝岗店',
						write: '',
						detailadress: '广州市|黄浦区',
						style: '区域代理商',

					},
					{
						adress: '广州',
						name: '金海岸花园店',
						write: '',
						detailadress: '广州市|番禺区',
						style: '区域代理商',

					},
					{
						adress: '广州',
						name: '南方国际广场',
						write: '',
						detailadress: '深圳市|福田区',
						style: '区域代理商',

					},
					{
						adress: '广州',
						name: '福田Kkone店',
						write: '',
						detailadress: '深圳市|福田区',
						style: '区域代理商',

					},
					{
						adress: '广州',
						name: 'SOLOPICK店铺（大白）',
						write: '',
						detailadress: '广州市|荔湾区',
						style: '区域代理商',

					},
					{
						adress: '广州',
						name: '微滨IFS国金中心店',
						write: '',
						detailadress: '长沙市|芙蓉区',
						style: '区域代理商',

					},
				]
			}
		},
		watch: {
			currentindex(newValue, oldValue) {
				if (newValue == 0) {
					this.bsTitle = ['经营渠道', '官方网店']
				} else if (newValue == 1) {
					this.bsTitle = ['经营渠道', '线下渠道']
				}
			}
		},
		methods: {
			choose(index) {
				this.currentindex = index;
			},
			open(index) {
				if (index == 0) {
					window.open('https://leravan.tmall.com/?spm=a1z10.3-b-s.w5001-21792119858.2.2f825759flC96i')
				} else if (index == 1) {
					window.open('https://mall.jd.com/index-715012.html')
				} else if (index == 2) {
					window.open('https://m.xiaomiyoupin.com/api/zhaoshang/shop?id=7ej_Id8veGf38AFI25SY7Q')
				}
			},

			getvalue(event) {
				// console.log("e", event.target.value)
				let that = this
				that.values = event.target.value
			}

		}

	}
</script>

<style>
	.topbg {
		max-height: 16.5rem;
		width: 100%;
		height: 28.5rem;
		background-repeat: no-repeat;
		background-position: center;
		background-origin: content-box;
		background-size: 100% auto;
		display: flex;
		justify-content: center;
		align-items: center;

	}

	#Official {
		width: 67.5rem;
		margin: 0 auto;
	}

	#Official .top {
		width: 40.125rem;
		height: 8rem;
	}

	#Official .top .box {
		width: 13rem;
		height: 3.125rem;
		float: left;
		position: relative;
		top: 20%;
		padding: 1.875rem;
		font-family: Alibaba-PuHuiTi-M;
	}

	#Official .top .box span {
		height: 3.1875rem;
		font-size: 18px;
		 
		font-weight: 500;
		color: rgba(24, 24, 24, 1);
		line-height: 1.875rem;
		float: left;
		cursor: pointer;
	}

	#Official .top .box .line {

		height: 0.6875rem;
		margin-left: 8.125rem;
		opacity: 0.2;
		line-height: 1.875rem;
	}

	#Official .top .box span.active {
		border-bottom: 0.15rem #00C785 solid;

	}


	#Official .top .title {
		width: 43.75rem;
		height: 5.9375rem;
		margin: 0 auto;
	}

	#Official .center {
		width: 55.75rem;
		height: 8.125rem;
		padding: 0.9375rem;
		font-family: Alibaba-PuHuiTi-M;
	}

	#Official .center .svg {
		padding: 0.625rem;
		float: left;
	}

	#Official .center .letter {
		width: 38.75rem;
		height: 4.375rem;
		float: left;
		margin-left: 6%;
	}

	#Official .center .letter .span {
		width: 7.8125rem;
		height: 1.875rem;
		font-size: 1rem;
		 
		font-weight: 500;
		color: rgba(24, 24, 24, 1);
		line-height: 4.5rem;
		float: left;
		padding: 0.625rem;
		padding-left: 4.375rem;
	}
</style>

<style>
	.shell {
		/* display: flex; */
		padding-top: 5rem;
	}

	.totalname {
		width: 49%;
		height: 1.9375rem;
		font-size: 1rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(24, 24, 24, 1);
		float: left;
		text-align: left;
	}

	.choose {
		width: 20%;
		float: left;
		text-align: right;
		position: relative;
		left: 30%;
	}

	.choose select {
		width: 100%;
		height: 3rem;
		background: rgba(244, 244, 244, 1);
		border-radius: 3.75rem;
		padding-left: 2.5rem;
		appearance: none;
		position: relative;
		right: 2%;
		border: solid 1px #fff;
		outline: none;
	}

	.shopbox {
		clear: both;
		width: 100%;
		display: flex;
		/* justify-content: space-between; */
		text-align: center;
		align-items: center;
		flex-direction: row;
		flex-wrap: wrap;
		padding-top: 3.125rem;
		margin-bottom: 5rem;
	}

	.choose .svg {
		position: absolute;
		left: 3%;
		top: 30%;
		z-index: 99;
	}

	.choose .updownsvg {
		position: absolute;
		left: 80%;
		top: 20%;
		z-index: 99;
	}

	.shopbox .shopshell {
		width: 32%;
		margin-top: 0.625rem;
		margin-bottom: 0.625rem;
		margin-right: 0.8rem;

	}

	.shopbox .shop {
		width: 100%;
		height: 145px;
	}

	.shopbox .shopshell {
		background: rgba(244, 244, 244, 1);
	}

	.shopbox .shop .shop-title {
		line-height: 3.125rem;
		width: 80%;
		margin: 0 auto;
		font-size: 1rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(24, 24, 24, 1);
		text-align: left;
	}

	.shopbox .shop .shop-write {
		width: 80%;
		height: 25%;
		margin: 0 auto;
		text-align: left;
		font-size: 0.8rem;
		 
		font-weight: 400;
		color: rgba(95, 95, 95, 1);
	}

	.shopbox .shop .shop-adress {
		width: 70%;
		font-size: 0.8rem;
		 
		font-weight: 400;
		color: rgba(95, 95, 95, 1);
		line-height: 55px;
		padding-left: 2%;
		text-align: left;
	}

	.shopicon {

		padding-top: 6.5%;
	}

	.shopbox .shop .shop-flag {
		width: 50%;
		text-align: right;
		font-size: 0.8rem;
		 
		font-weight: 650;
		color: rgba(95, 95, 95, 1);
		line-height: 55px;
	}
</style>

<style>
	.bottomshell {
		margin-top: 3.125rem;
		/* margin-left: %; */
		width: 96%;
		/* margin: 0 auto; */
		background: rgba(244, 244, 244, 1);
		padding-bottom: 5%;
		margin-bottom: 5%;
	}

	.bottomshell .bottomshell-top {
		padding-left: 9.5%;
		padding-top: 3%;
		font-size: 1rem;
		font-family: Alibaba-PuHuiTi-M; 
		font-weight: 550;
		color: rgba(24, 24, 24, 1);
		text-align: left;
	}

	.bottomshell .bottomshell-center {
		display: flex;
		justify-content: flex-start;
		padding-left: 9.5%;
	}

	.bottomshell .bottomshell-center .bottomshell-center-box {
		/* border: 1px solid red; */
		text-align: left;
	}

	.bottomshell .bottomshell-center .bottomshell-center-box-name {
		/* width: 138px; */
		/* height: 29px; */
		font-size: 1rem;
		 
		font-weight: 400;
		color: rgba(95, 95, 95, 1);
		line-height: 3.125rem;
	}

	.bottomshell .bottomshell-center .bottomshell-center-box-info {

		font-size: 0.8rem;
		 
		font-weight: 400;
		color: rgba(95, 95, 95, 1);
		line-height: 20px;
	}
</style>
